/**
 * Portable JSON document exporter for Paper2Ink.
 * Spec reference: .hermes/plans/2026-09-16_195645-paper2ink-saas-spec.md (§5.5, SAAS-216).
 *
 * Rules:
 * - Default export detaches source image assets (source_deleted: true, asset IDs null).
 * - Optional source inclusion when explicitly requested.
 * - Enforces full CIMDocument contract validation before serialization.
 */

import { validateCIMDocument, type CIMDocument } from '../editor/model.ts';

export interface JSONExportOptions {
  includeSource?: boolean;
  pretty?: boolean;
}

export function exportToJSON(doc: CIMDocument, options?: JSONExportOptions): string {
  validateCIMDocument(doc);

  const includeSource = options?.includeSource ?? false;
  const pretty = options?.pretty ?? true;

  const exportDoc: CIMDocument = structuredClone(doc);

  if (!includeSource) {
    exportDoc.source = {
      ...exportDoc.source,
      source_deleted: true,
      original_asset_id: null,
      normalized_asset_id: null,
      prepared_asset_id: null,
    };
  }

  return pretty ? JSON.stringify(exportDoc, null, 2) : JSON.stringify(exportDoc);
}
